<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page" [dir]="isAr ? 'rtl' : 'ltr'">
  <div class="bb-page-shell">
    <div class="bb-page-header">
      <div class="bb-page-title-block">
                             <span class="bb-eyebrow">{{ 'add order' | transloco }}</span>
        <h2 class="bb-page-title">{{ "add order" | transloco }}</h2>
      </div>
    </div>

    <form class="bb-card bb-p-20" [formGroup]="data" (ngSubmit)="onSubmit()">
      <div class="bb-form-grid">
        @if(submitted && (data.invalid || hasNoSelectedItems() || hasInvalidSelectedItems())) {
        <div class="bb-form-alert bb-field-full" role="alert">
          {{ 'Review the order data before saving' | transloco }}
          @if(getMissingRequiredCount() > 0) {
          <span>
            ({{ getMissingRequiredCount() }} {{ 'required fields' | transloco }})
          </span>
          }
        </div>
        }

        <!-- Product Selection -->
        <div class="bb-field bb-field-full bb-chip-select" *ngIf="selectedValueFromStock">
          <label class="bb-label bb-chip-label">{{ "select product" | transloco }}</label>

          <mat-form-field class="bb-chip-mat-field" appearance="outline">
            <mat-chip-grid #chipGrid class="bb-chip-grid-custom">
              <mat-chip-row
                *ngFor="let item of selectedProductsDetails; trackBy: trackByProduct"
                (removed)="removeProduct(item.product.id)"
                class="bb-chip-item bb-chip-item-product"
              >
                {{ item.product.name_ar }}

                <button matChipRemove type="button" class="bb-chip-remove-btn">
                  ×
                </button>
              </mat-chip-row>

              <input
                matInput
                class="bb-chip-input"
                placeholder="{{ 'select product' | transloco }}"
                [value]="searchValue"
                (input)="onSearchChange($event)"
                [matAutocomplete]="auto"
                [matChipInputFor]="chipGrid"
              />
            </mat-chip-grid>
          </mat-form-field>

          @if(shouldShowItemsError()) {
          <div class="bb-field-error">
            {{ 'Select at least one product' | transloco }}
          </div>
          }
        </div>

        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="addProduct($event)"
          class="bb-chip-autocomplete-panel"
        >
          <mat-option *ngFor="let product of filteredProviders" [value]="product">
            {{ product.name_ar }} -

            @switch (accounttype) {
            @case ("2") { {{product.affiliationprice}} }
            @case ("3") { {{product.pricea}} }
            @case ("4") { {{product.priceb}} }
            @case ("5") { {{product.pricec}} }
            @default { {{product.price}} }
            }

            {{ 'egp' | transloco }} -
            {{ product.quantity }}
          </mat-option>
        </mat-autocomplete>

        <!-- Clear Client Button -->
        <div class="bb-field bb-field-full" *ngIf="clearClientBtn">
          <button (click)="clearClient()" class="bb-btn bb-btn-secondary" role="button">
            {{ 'clear client' | transloco }}
          </button>
        </div>

        <!-- Client Information -->
        <div class="bb-field">
          <label class="bb-label" for="client_name">{{ 'client name' | transloco }}</label>
          <input
            class="bb-input"
            type="text"
            id="client_name"
            formControlName="client_name"
            placeholder="{{ 'client name' | transloco }}"
            [(ngModel)]="client_name"
            [ngClass]="{
              'is-invalid': data.get('client_name')?.touched && data.get('client_name')?.invalid,
              'is-valid': data.get('client_name')?.touched && data.get('client_name')?.valid
            }"
          />
          @if(shouldShowError('client_name')) {
          <div class="bb-field-error">{{ getErrorMessage('client_name', ('client name' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field">
          <label class="bb-label" for="phone_number">{{ 'Phone Number' | transloco }}</label>
          <input
            class="bb-input"
            type="text"
            id="phone_number"
            formControlName="phone_number"
            placeholder="{{ 'Phone Number' | transloco }}"
            [(ngModel)]="phone_number"
            [ngClass]="{
              'is-invalid': data.controls['phone_number'].touched && data.controls['phone_number'].errors,
              'is-valid': data.controls['phone_number'].touched && !data.controls['phone_number'].errors,
              'is-touched': data.controls['phone_number'].untouched && !data.controls['phone_number'].errors,
            }"
          />
          @if(shouldShowError('phone_number')) {
          <div class="bb-field-error">{{ getErrorMessage('phone_number', ('Phone Number' | transloco)) }}</div>
          }
        </div>

        <!-- Address -->
        <div class="bb-field bb-field-full">
          <label class="bb-label" for="address">{{ 'address' | transloco }}</label>
          <input
            class="bb-input"
            type="text"
            id="address"
            formControlName="address"
            placeholder="{{ 'address' | transloco }}"
            [(ngModel)]="address"
            [ngClass]="{
              'is-invalid': data.controls['address'].touched && data.controls['address'].errors,
              'is-valid': data.controls['address'].touched && !data.controls['address'].errors,
              'is-touched': data.controls['address'].untouched && !data.controls['address'].errors,
            }"
          />
          @if(shouldShowError('address')) {
          <div class="bb-field-error">{{ getErrorMessage('address', ('address' | transloco)) }}</div>
          }
        </div>

        <!-- Governorate & City -->
        <div class="bb-field">
          <label class="bb-label">{{ "Select Governorate" | transloco }}</label>
          <div class="bb-select-wrap">
            <select
              class="bb-select"
              formControlName="government_id"
              [(ngModel)]="government_id"
              (change)="loadCities($event)"
              [ngClass]="{
                'is-invalid': data.controls['government_id'].touched && data.controls['government_id'].errors,
                'is-valid': data.controls['government_id'].touched && !data.controls['government_id'].errors,
                'is-touched': data.controls['government_id'].untouched && !data.controls['government_id'].errors,
              }"
            >
              <option value="">{{ "Select Governorate" | transloco }}</option>
              <option *ngFor="let gov of governorates" [value]="gov.id">
                {{ isAr ? gov.governorate_name_ar : gov.governorate_name_en }}
              </option>
            </select>
          </div>
          @if(shouldShowError('government_id')) {
          <div class="bb-field-error">{{ getErrorMessage('government_id', ('Select Governorate' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field">
          <label class="bb-label">{{ "Select area" | transloco }}</label>
          <div class="bb-select-wrap">
            <select
              class="bb-select"
              formControlName="city_id"
              [(ngModel)]="city_id"
              [ngClass]="{
                'is-invalid': data.controls['city_id'].touched && data.controls['city_id'].errors,
                'is-valid': data.controls['city_id'].touched && !data.controls['city_id'].errors,
                'is-touched': data.controls['city_id'].untouched && !data.controls['city_id'].errors,
              }"
            >
              <option value="">{{ "Select area" | transloco }}</option>
              <option *ngFor="let city of cities" [value]="city.id">
                {{ isAr ? city.city_name_ar : city.city_name_en }}
              </option>
            </select>
          </div>
          @if(shouldShowError('city_id')) {
          <div class="bb-field-error">{{ getErrorMessage('city_id', ('Select area' | transloco)) }}</div>
          }
        </div>

        <!-- Note -->
        <div class="bb-field bb-field-full">
          <label class="bb-label" for="note">{{ 'note' | transloco }}</label>
          <input
            class="bb-input"
            type="text"
            id="note"
            formControlName="note"
            placeholder="{{ 'note' | transloco }}"
            [(ngModel)]="note"
            [ngClass]="{
              'is-invalid': data.controls['note'].touched && data.controls['note'].errors,
              'is-valid': data.controls['note'].touched && !data.controls['note'].errors,
              'is-touched': data.controls['note'].untouched && !data.controls['note'].errors,
            }"
          />
        </div>

        <!-- Create Order By User (Admin Only) -->
        @if(showAllUsers){
        <div class="bb-field bb-field-full">
          <label class="bb-label" for="createby">{{ 'create this order by' | transloco }}</label>
          <div class="bb-select-wrap">
            <select
              id="createby"
              class="bb-select"
              (ngModelChange)="onitemchange($event)"
              formControlName="createby"
              [ngClass]="{
                'is-invalid': data.get('createby')?.touched && data.get('createby')?.invalid,
                'is-valid': data.get('createby')?.touched && data.get('createby')?.valid
              }"
            >
              <option value="" disabled selected>{{ 'select' | transloco }}</option>
              @for (user of users; track user) {
              <option [value]="user.id +'type'+ user.type">{{user.last_name}}</option>
              }
            </select>
          </div>
          @if(shouldShowError('createby')) {
          <div class="bb-field-error">{{ getErrorMessage('createby', ('create this order by' | transloco)) }}</div>
          }
        </div>
        }

        <!-- Update Mode: Selected Products Summary -->
        @if(isUpdate){
        <div class="bb-field bb-field-full">
          <label class="bb-label">{{ 'Selected Items' | transloco }}</label>

          <div *ngFor="let item of selectedProductsDetails" class="bb-card bb-p-16 bb-mb-12">
            <div class="bb-text-stack">
              <p class="bb-m-0 bb-font-bold">
                <strong>{{ 'المنتج:' | transloco }}</strong> {{ item.product.name_ar }}
              </p>

              <label class="bb-label">
                <strong>{{ 'الكمية:' | transloco }}</strong>
                <input
                  type="number"
                  class="bb-input bb-mt-8"
                  [(ngModel)]="item.quantity"
                  min="1"
                  name="quantity{{item.product.id}}"
                />
              </label>

              <p class="bb-m-0 bb-price">
                <strong>{{ 'السعر:' | transloco }}</strong> {{ item.price }} {{ 'جنيه' | transloco }}
              </p>
            </div>
          </div>
        </div>
        }
        @else{
        <!-- Normal Mode: Products Table -->
        <div class="bb-field bb-field-full" *ngIf="selectedProductsDetails.length > 0">
          <label class="bb-label">{{ 'Product' | transloco }}</label>

          <div class="bb-table-scroll">
            <table class="bb-table">
              <thead>
                <tr>
                  <th class="mat-header-cell-custom">{{ 'Product' | transloco }}</th>
                  <th class="mat-header-cell-custom" *ngIf="!isMobile">{{ 'quantity' | transloco }}</th>
                  <th class="mat-header-cell-custom">
                    @if(warehouseIsStore){ {{ 'Bonus' | transloco }} } @else { {{ 'price' | transloco }} }
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let item of selectedProductsDetails">
                  @if(isMobile){
                  <td class="mat-cell-custom">
                    <div class="bb-text-stack">
                      <div class="bb-product-title">{{ item.product.name_ar }}</div>

                      <div class="bb-grid bb-gap-8">
                        <input
                          type="number"
                          class="bb-input"
                          placeholder="{{ 'quantity' | transloco }}"
                          formControlName="quantity"
                          min="1"
                          [(ngModel)]="item.quantity"
                        />

                        <input
                          class="bb-input"
                          formControlName="price"
                          placeholder="{{ !warehouseIsStore ? ('price' | transloco) : ('Bonus' | transloco) }}"
                          type="number"
                          min="0"
                          [(ngModel)]="item.bounes"
                        />
                      </div>
                    </div>
                  </td>
                  }@else{
                  <td class="mat-cell-custom bb-font-bold">{{ item.product.name_ar }}</td>

                  <td class="mat-cell-custom">
                    <input
                      type="number"
                      class="bb-input"
                      formControlName="quantity"
                      min="1"
                      [(ngModel)]="item.quantity"
                    />
                  </td>

                  <td class="mat-cell-custom">
                    <input
                      class="bb-input"
                      formControlName="price"
                      type="number"
                      min="0"
                      *ngIf="!warehouseIsStore"
                      [(ngModel)]="item.price"
                    />

                    <input
                      class="bb-input"
                      formControlName="bounes"
                      placeholder="{{ 'Bonus' | transloco }}"
                      type="number"
                      min="0"
                      *ngIf="warehouseIsStore"
                      [(ngModel)]="item.bounes"
                    />
                  </td>
                  }
                </tr>
              </tbody>
            </table>
          </div>

          @if(shouldShowSelectedItemsError()) {
          <div class="bb-field-error bb-mt-8">
            {{ 'Review selected product quantity and price' | transloco }}
          </div>
          }
        </div>
        }

        <!-- QR Code Checkbox -->
        <div class="bb-field bb-field-full" *ngIf="!warehouseIsStore">
          <label class="bb-check-line">
            <input
              class="bb-checkbox"
              type="checkbox"
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="hasQrOffer"
            />
            <span>{{ "Create QR Code" | transloco }}</span>
          </label>
        </div>

        <!-- Hidden Form Anchor -->
        <div #formElement></div>

        <!-- Submit / Update Button -->
           <div class="bb-field bb-field-full bb-mt-16">
          @if(isUpdate){
          <button type="button" (click)="updateOrder()" class="bb-btn bb-btn-primary bb-btn-wide">
            {{ "update" | transloco }}
          </button>
          }@else{
          <button
            type="submit"
            class="bb-btn bb-btn-primary bb-btn-wide"
            [class.is-disabled]="data.invalid || hasNoSelectedItems() || hasInvalidSelectedItems()"
          >
            {{ "Submit" | transloco }}
          </button>
          }
        </div>
      </div>
    </form>
  </div>
</section>